/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const bulkContactResultDtoSchema = z.object({
    "contactId": z.uuid(),
"success": z.boolean(),
"error": z.optional(z.string().describe("Why this contact failed, e.g. 'Contact not found: <id>'"))
    })